'use client';

import {styled} from '@mui/material/styles';
import NextLink from 'next/link';
import type {ReactNode} from 'react';
import {linkShouldForwardProp, type LinkBaseProps} from './link-base';
import {Typography, type FontWeight} from './Typography';

export type MenuLinkType = 'desktop' | 'mobile';

export interface MenuLinkProps extends Omit<LinkBaseProps, 'size'> {
  type?: MenuLinkType;
  active?: boolean;
  weight?: FontWeight;
  icon?: ReactNode;
}

const MENU_LINK_FONT_SIZE = {desktop: 'body-2', mobile: 'body-1'} as const;

const Root = styled(NextLink, {shouldForwardProp: linkShouldForwardProp})(({theme}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.colors.text.neutral.inverse,
  textDecoration: 'none',
  '&:hover, &[aria-current="page"]': {color: theme.palette.colors.text.primary.inverse},
}));

export function MenuLink({type = 'desktop', active, weight = 'medium', icon, children, ...rest}: MenuLinkProps) {
  return (
    <Root aria-current={active ? 'page' : undefined} {...rest}>
      {icon}
      <Typography as="span" family="primary" size={MENU_LINK_FONT_SIZE[type]} weight={weight} sx={{color: 'inherit', letterSpacing: 0}}>
        {children}
      </Typography>
    </Root>
  );
}

MenuLink.displayName = 'MenuLink';
